import React from "react";
import { Modal } from "react-bootstrap";

import "./ConfirmQuitModal.scss";

export default function ConfirmQuitModal(props) {
  const { showModal, handleModalToggle, handleConfirmQuit } = props;
  const handleClick = (event) => {
    if (event.target.id === "yes") {
      handleConfirmQuit(true);
    } else if (event.target.id === "no") {
      handleConfirmQuit(false);
    }
  };
  return (
    <Modal show={showModal} size="sm" fullscreen={""} onHide={() => handleModalToggle(false)} aria-labelledby="example-custom-modal-styling-title" className="confirm_quit_modal">
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">Sure you want to exit</Modal.Title>
      </Modal.Header>
      <Modal.Body onClick={handleClick}>
        <button id="no" className="button">
          Cancel
        </button>
        <button id="yes" className="button button_primary">
          Quit
        </button>
      </Modal.Body>
    </Modal>
  );
}
